import knightsConstantRedux from "../constant";
const initialViewSettings = {
  showCategoryMenu: "hide-category",
  fundOpen: false,
  boxId: 0,
  boxLabel: 0,
};
const viewSettings = (state = initialViewSettings, action, root) => {
  switch (action.type) {
    case knightsConstantRedux.SET_SHOW_HIDE_CATEGORY:
      return {
        ...state,
        showCategoryMenu: action.payload.showCategoryMenu,
      };
    case knightsConstantRedux.SET_FUND_OPEN:
      return {
        ...state,
        fundOpen: action.payload.fundOpen,
        boxId: action.payload.boxId,
      };

    default:
      return state;
  }
};
export default viewSettings;
